import * as types from '../constants/ActionTypes';

const initialState = {
	response: {},
	message: '',
	hide: true,
	type: '',
	id: Math.random(), // necessary for differentiating new global messages
};

export default function globalMsg(state = initialState, action) {
	switch (action.type) {

		//SHOW ERROR
		case types.RECEIVE_USER_LIST_ERROR:

		case types.RECEIVE_CORP_LIST_ERROR:
		case types.RESOLVE_EDIT_CORP_ERROR:

		case types.RECEIVE_FEED_LIST_ERROR:

		case types.RECEIVE_BUILDER_LIST_ERROR:
		case types.RESOLVE_EDIT_BUILDER_ERROR:
		case types.RECEIVE_BUILDER_ERROR:

		case types.RECEIVE_SUBDIVISION_LIST_ERROR:
		case types.RESOLVE_EDIT_SUBDIVISION_ERROR:
		case types.RESOLVE_BULK_EDIT_CUSTOMERS_ERROR:

		case types.RECEIVE_REPORT_ERROR:
			return {
				...state,
				...action.error,
				type: 'error',
				hide: false,
				id: Math.random(),
			};

		//SHOW SUCCESS
		case types.RESOLVE_EDIT_USER:
		case types.RESOLVE_ADD_USER:
			return {
				...state,
				message: 'The user has been saved!',
				type: 'success',
				hide: false,
				id: Math.random(),
			};
		case types.RESOLVE_EDIT_FEED:
		case types.RESOLVE_ADD_FEED:
			return {
				...state,
				message: 'The feed has been saved!',
				type: 'success',
				hide: false,
				id: Math.random(),
			};
		case types.RESOLVE_FORCE_FEED:
			return {
				...state,
				message: `Feed #${action.feed.id} has been forced to run! It will be processed during the next cycle.`,
				type: 'success',
				hide: false,
				id: Math.random(),
			};
		case types.RESOLVE_DELETE_FEED:
			return {
				...state,
				message: `Feed #${action.feedId} has been deleted!`,
				type: 'success',
				hide: false,
				id: Math.random(),
			};
		case types.RESOLVE_EDIT_CUSTOMER:
		case types.RESOLVE_ADD_MY_CUSTOMER:
		case types.RESOLVE_ADD_NOT_MY_CUSTOMER:
			return {
				...state,
				message: 'The customer has been saved!',
				type: 'success',
				hide: false,
				id: Math.random(),
			};

		//CLEAR OUT for error only!!
		case types.RECEIVE_USER_LIST:
		case types.RECEIVE_CORP_LIST:
		case types.RECEIVE_FEED_LIST:
			if (state.type === 'error') {
				return initialState;
			}
			return state;

		case types.SET_GLOBAL_MSG:
			return {
				...state,
				type: action.level,
				message: action.message,
				id: Math.random(),
			};

		//CLEAR TO INITIAL STATE
		case '@@router/LOCATION_CHANGE':
		case types.CLEAR_GLOBAL_MSG:
			return initialState;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/global-msg.js